import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ContextMenuOperationsService {
  private contextMenuOperationData: Subject<any> = new Subject();
  contextMenuOperationData$ = this.contextMenuOperationData.asObservable();

  private contextMenuServiceData: Subject<any> = new Subject();
  contextMenuServiceData$ = this.contextMenuServiceData.asObservable();

  constructor() {

  }

  setContextMewnuOperation(data) {
    this.contextMenuOperationData.next(data);
  }

  setcontextMenuServiceData(data) {
    this.contextMenuServiceData.next(data);
  }
}
